// https://medium.com/@Taha_Shashtari/the-easy-way-to-change-page-title-in-vue-6caf05006863
// https://github.com/vuejs/vue-hackernews-2.0/blob/master/src/util/title.js

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}
export default {
  created() {
    if (
      this.$route.name != "themes" &&
      this.$route.name != "countries" &&
      this.$route.name != "itineraries"
    ) {
      const title = getTitle(this);
      if (title) {
        document.title = title;
      }
    }
  },
};
